app.controller('HomeController', ['$scope', '$rootScope', 'AuthenticationService', function ($scope, $rootScope, AuthenticationService) {
    
    //SuperAdmin
    $rootScope.EnumRole= {
        SuperAdmin: 1,
        Admin: 2,
        Author: 3,
        Corrector: 4,
        Translator: 5
    }

    $rootScope.RoleForPagesConsultation = [$rootScope.EnumRole.SuperAdmin, $rootScope.EnumRole.Admin, $rootScope.EnumRole.Author, $rootScope.EnumRole.Corrector, $rootScope.EnumRole.Translator];
    $rootScope.RoleForPagesCorrection = [$rootScope.EnumRole.SuperAdmin, $rootScope.EnumRole.Admin, $rootScope.EnumRole.Author, $rootScope.EnumRole.Corrector];
    $rootScope.RoleForPagesTranslation = [$rootScope.EnumRole.SuperAdmin, $rootScope.EnumRole.Admin, $rootScope.EnumRole.Translator];
    $rootScope.RoleForPagesCreation = [$rootScope.EnumRole.SuperAdmin, $rootScope.EnumRole.Admin, $rootScope.EnumRole.Author];
    $rootScope.RoleForPagesAdmin = [$rootScope.EnumRole.SuperAdmin, $rootScope.EnumRole.Admin];
}]);
